import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { cardsStore } from '../../store/cardsStore';
import { CARDS_TYPE, TABLE_CARDS } from '../../enums/cardTypes';
import { BOX_CARDS_COUNT, TABLE_BOX_TYPES } from '../../enums/betTypesEnum';

export const ExtraBetsCardsSection = observer(() => {
  const { dealerCards, boxCards } = cardsStore;
  const t = useTranslation();

  const cardsByBox = useMemo(() => {
    return boxCards.reduce((acc, cur) => {
      if (acc[cur.boxIndex]) {
        acc[cur.boxIndex].push(cur);
      } else {
        acc[cur.boxIndex] = [cur];
      }
      return acc;
    }, {});
  }, [boxCards]);

  return (
    <div className='main-cards-top-container-row'>
      <div className='main-cards-top-cont-inner'>
        {/* TODO wait cards */}
        {/* ADD class " disabled " */}
        {TABLE_CARDS.map((item, index) => {
          if (dealerCards[index]?.card || dealerCards[index]?.card === 0) {
            return (
              <div
                key={item}
                className={`card-top-boxes card-deck-2 ${CARDS_TYPE[dealerCards[index]?.card]}`}
              />
            );
          }
          return <div key={item} className='card-top-boxes' />;
        })}
      </div>
      <div className='hand-pos-wrapper-mob'>
        {TABLE_BOX_TYPES.map((item, i) => (
          <div key={item} className='hand-pos-box'>
            {/*    /!* ADD class " state-gray " *!/ */}
            <p className='hand-pos-box-title state-gray'>
              {t('HAND')} <span>{i + 1}</span>
            </p>
            <div className='head-card-hand-box'>
              {BOX_CARDS_COUNT.map((cur, index) => (
                <div
                  key={cur}
                  className={`head-card-hand-box-img ${
                    Number.isInteger(cardsByBox[i + 1]?.[index]?.card)
                      ? `card-deck-2 ${CARDS_TYPE[cardsByBox[i + 1][index]?.card]}`
                      : ''
                  }`}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
